import React from 'react';

function PalliativeCareBlog() {
  return (
    <div>
    <iframe
      src="https://palliativecaremanjeri.blogspot.com/?m=1"
      title="Palliative Care Manjeri"
      width="100%"
      height="1000px"
      style={{ border: 'none' }}
    />
    </div>
  );
}

export default PalliativeCareBlog;
